/**
 * @file During the bootflow a few parameters are tested.
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { SettingsService } from './settings.service';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from './authentication.service';
import { ErrorService } from './core/error.service';
import { VersionCompare } from './base/helpers/version-compare';
var TestService = /** @class */ (function () {
    /**
    * Creates an instance of TestService.
    * @param {HttpClient} httpClient
    * @param {SettingsService} settingsService
    * @param {AuthenticationService} authenticationService
    * @param {ErrorService} errorService
    * @memberof TestService
    */
    function TestService(httpClient, settingsService, authenticationService, errorService) {
        this.httpClient = httpClient;
        this.settingsService = settingsService;
        this.authenticationService = authenticationService;
        this.errorService = errorService;
        this.results = {};
    }
    /**
    * Methode is part of Bootflow in app.module.ts
    */
    TestService.prototype.bootInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.testVersions()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.testAccountHealth()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TestService.prototype.testVersions = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var runningVersions, requirements;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.get(this.settingsService.settings.frontend.versions.uri).toPromise()];
                    case 1:
                        runningVersions = _a.sent();
                        // Expect a few properties
                        if (!runningVersions.Symagic) {
                            this.errorService.addError(new Error('Can not retrieve the Symagic Server version.'));
                        }
                        if (!runningVersions.API) {
                            this.errorService.addError(new Error('Can not retrieve the API Server version.'));
                        }
                        requirements = {
                            'symagic-server-version': this.settingsService.settings.frontend.versions.server,
                            'api-server-version': this.settingsService.settings.frontend.versions.api
                        };
                        if (!VersionCompare.same_or_higher(runningVersions.Symagic, requirements['symagic-server-version'])) {
                            this.errorService.addError(new Error("Symagic Server (v" + runningVersions.Symagic + ") does not meet requirements (v" + requirements['symagic-server-version'] + ")"));
                        }
                        if (!VersionCompare.same_or_higher(runningVersions.API, requirements['api-server-version'])) {
                            this.errorService.addError(new Error("API Server (v" + runningVersions.API + ") does not meet requirements (v" + requirements['api-server-version'] + ")"));
                        }
                        // Save results
                        this.results['symagic-server-version'] = runningVersions.Symagic;
                        this.results['api-server-version'] = runningVersions.API;
                        return [2 /*return*/];
                }
            });
        });
    };
    TestService.prototype.testAccountHealth = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var planningDomain, accountHealth;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        planningDomain = this.settingsService.settings.frontend.domains.find(function (d) { return d.name === 'planning'; });
                        if (!planningDomain) {
                            this.errorService.addError(new Error('Can not find the Planning domain for retrieving account health data.'));
                        }
                        return [4 /*yield*/, this.httpClient.get(planningDomain.uri + '/AccountHealthItems').toPromise()];
                    case 1:
                        accountHealth = (_a.sent())[0];
                        // Expect a few properties
                        if (accountHealth.hasUser === undefined) {
                            this.errorService.addError(new Error('Account health data is missing a property (hasUser)'));
                        }
                        if (accountHealth.hasResource === undefined) {
                            this.errorService.addError(new Error('Account health data is missing a property (hasResource)'));
                        }
                        if (accountHealth.hasHTML5Role === undefined) {
                            this.errorService.addError(new Error('Account health data is missing a property (hasHTML5Role)'));
                        }
                        if (accountHealth.isEnabled === undefined) {
                            this.errorService.addError(new Error('Account health data is missing a property (isEnabled)'));
                        }
                        // Check if the account is healthy
                        if (!accountHealth.hasUser === true) {
                            this.errorService.addError(new Error('APP.ERROR_HANDLING.ACCOUNT_NO_USER'));
                        }
                        if (!accountHealth.hasResource === true) {
                            this.errorService.addError(new Error('APP.ERROR_HANDLING.ACCOUNT_NO_RESOURCE'));
                        }
                        if (!accountHealth.hasHTML5Role === true) {
                            this.errorService.addError(new Error('APP.ERROR_HANDLING.ACCOUNT_NO_HTML5ROLE'));
                        }
                        if (!accountHealth.isEnabled === true) {
                            this.errorService.addError(new Error('APP.ERROR_HANDLING.ACCOUNT_DISABLED'));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return TestService;
}());
export { TestService };
